<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="AssetFlow"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        采购申请
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <!-- 坐班指纹打卡 -->
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">OA采购申请流程</h4>
                    <p class="labourParticulars-title-content-active">第一步：登录OA系统（oa.xdf.cn，账户密码与个人企业邮箱同步），点击【OA系统】。</p>
                    <p class="labourParticulars-title-content-active">第二步：点击【工作流】-【新建工作】-【标准化流程】-【资产管理】-【物资采购申请流程】-【新建并办理】，新建表单。</p>
                    <p class="labourParticulars-title-content-active">第三步：根据界面提示填写采购需求，完善标星处信息。【采购原因】中需要写明部门、校区名称及需求物资名称；【备注】中需填写详细收货信息（联系人、联系电话、详细地址等）；如需申请多项物资，点击【新增】填写。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">OA采购申请流程</h4>
                    <p class="labourParticulars-title-content-active">第四步：第四步：如有附件可点击【添加附件】进行上传。确认无误后点击【提交】，每日关注OA流程进度，及时转交下一步。</p>
                    <p class="labourParticulars-title-content-active">第五步：申请部门负责人审批采购</p>
                    <p class="labourParticulars-title-content-active">第六步：机构资产管理部代表审核采购申请</p>
                    <p class="labourParticulars-title-content-active">第七步：采购询价</p>
                    <p class="labourParticulars-title-content-active">第八步：采购申请人核对采购物资</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">OA采购申请流程</h4>
                    <p class="labourParticulars-title-content-active">第九步：采购申请部门负责人/区域总监确认采购物资</p>
                    <p class="labourParticulars-title-content-active">第十步：机构资产管理部代表审核采购物资</p>
                    <p class="labourParticulars-title-content-active">第十一步：机构财务负责人预算审核</p>
                    <p class="labourParticulars-title-content-active">第十二步：机构负责人审批采购</p>
                    <p class="labourParticulars-title-content-active">第十三步：采购经办人确认是否签合同</p>
                    <p class="labourParticulars-title-content-active">第十四步：合同审批流程</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">OA采购申请流程</h4>
                    <p class="labourParticulars-title-content-active">第十五步：采购执行人借款冰执行采购</p>
                    <p class="labourParticulars-title-content-active">第十六步：保管人验收物资</p>
                    <p class="labourParticulars-title-content-active">第十七步：库管确认出入库</p>
                    <p class="labourParticulars-title-content-active">第十八步：报销（打印报销单、填写报销凭证、固定资产入库签字、财务报销）</p>
                    <img src="../../assets/8.jpeg" alt="" class="QRcode">
                    <sup id="box_text_content">长按观看视频教程</sup>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        fn() {
            
        },
        getOnPage(){
            this.$router.push({name: 'Search', params:{code:"1000"}})
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30% !important;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
#box_text_content {
    width: 100%;
    display: block;
    font-size: 12px;
    color: #ccc;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/assetflow/assetFlow1.vue